window.UpButton = (function () {
   
    const selectors = {
        btnUp: '#go-top',
        placeBtn: '.layout__body',
        placeBtnMobile: '[data-mtm-section="mobile-layout"]',
    };

    return {
        init: function () {
            this.renderBtn();
            this.bindUI();
        },
        bindUI: function () {
            var self = this;


            $(window).on('scroll touchmove', function () {
                self.scrollPageUp();
            });
            $(selectors.btnUp).click(function () {
                $(selectors.btnUp).css('pointer-events', 'none');
                self.scrollTopBtn();
                setTimeout(function () {
                    $(selectors.btnUp).css('pointer-events', '');
                }, 2000);
            });
        },
        htmlSvgIcon: function (filename, classname) {
            return '<svg class="icon ' + classname + '"><use xlink:href="/Content/cps/images/sprites/svg-icons.svg#' + filename + '"></use></svg>';
        },
        renderBtn: function () {
            $(selectors.placeBtn).append('<a href="#" class="up-button m-close" id="go-top">' + this.htmlSvgIcon('arrow', 'up-button__icon') + '</a>');
            $(selectors.placeBtnMobile).append('<a href="#" class="up-button m-mobile m-close" id="go-top">' + this.htmlSvgIcon('arrow', 'up-button__icon') + '</a>');
        },

        scrollPageUp: function () {
            if ($(window).scrollTop() <= "250") $(selectors.btnUp).addClass('m-close');
            else $(selectors.btnUp).removeClass('m-close');
        },

        scrollTopBtn: function () {
            $("html").animate({ scrollTop: 0 }, 1000);
        }
    }
}());